module.exports = {
    "expand": `Expand`,
    "collapse": `Collapse`
};


//# sourceMappingURL=en-US.main.js.map
